import React from 'react';
import {useMediaQuery, useTheme} from "@mui/material";
import {NavLink} from "react-router-dom";
import useBannerHomeStyles from "../../styles/ncp2026/banner_home";
import bannerCampanie from "../../assets/images/ncp/2026/banner_campanie.jpg";
import bannerCampanieMobile from "../../assets/images/ncp/2026/banner_campanie_mobile.jpg";
import {paths} from "../../AppRouters";

const BannerHome: React.FC = () => {
    const bannerHomeStyles = useBannerHomeStyles();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <NavLink to={paths.ncp2026} className={bannerHomeStyles.navLink}>
            <img 
                src={isMobile ? bannerCampanieMobile : bannerCampanie} 
                alt="Banner Campanie Kozel 2026" 
                className={bannerHomeStyles.bannerImage}
            />
        </NavLink>
    );
}

export default BannerHome;